import { Section, Flex } from '@farmersdog/corgi-x';
import { getLinkToFreshSignup } from '@farmersdog/tosa/src/utils/getLinkToSignupFlow';
import { PATH_SIGNUP_ME } from '@farmersdog/constants/paths';

import { useTrackedSectionRef } from 'src/hooks/useTrackedSections';
import { HomepageRedesignSections, CtaTrackerV2 } from '../../../CtaTrackerV2';
import { ExtendedText } from '../../../ExtendedText';
import { ExtendedButton } from '../../../ExtendedButton';

import styles from './VetsHero.module.css';

import LongUnderline from './assets/longUnderline.svg';
import ShortUnderline from './assets/shortUnderline.svg';
import { GiveUsACall } from '../../components/GiveUsACall';

const TITLE_DATA = [
  { left: 'Devoured', right: 'dogs', Underline: ShortUnderline },
  { left: 'Loved', right: 'humans', Underline: LongUnderline },
  { left: 'Trusted', right: 'vets', Underline: ShortUnderline },
];

const SeePlansAndPricingButton = () => {
  const linkToFreshSignup = getLinkToFreshSignup(PATH_SIGNUP_ME);
  return (
    <CtaTrackerV2
      type="select"
      moduleLevel={1}
      moduleName={HomepageRedesignSections.Hero}
    >
      <ExtendedButton
        variant="special"
        type="link"
        className={styles.button}
        to={linkToFreshSignup}
      >
        See Plans & Pricing
      </ExtendedButton>
    </CtaTrackerV2>
  );
};

export const VetsHero = () => {
  const sectionRef = useTrackedSectionRef(HomepageRedesignSections.Hero);

  return (
    <Section sectionRef={sectionRef} aria-label="Homepage Hero">
      <div className={styles.mobileWrapper}>
        <Flex direction="column">
          {TITLE_DATA.map(({ left, right, Underline }, index) => (
            <Flex
              key={index}
              gap="xs"
              justify="center"
              alignItems="center"
              aria-label={`${left} by ${right}`}
            >
              <div className={styles.titleLeft}>
                <ExtendedText variant="heading-28" bold color="kale-3">
                  {left}
                </ExtendedText>
              </div>
              <div>
                <ExtendedText variant="heading-28" bold color="kale-3">
                  by
                </ExtendedText>
              </div>
              <div className={styles.titleRight}>
                <div className={styles.lazyDogTextContainer}>
                  <ExtendedText
                    variant="lazy-dog-32"
                    color="kale-3"
                    as="div"
                    className={styles.lazyDogText}
                  >
                    {right}.
                  </ExtendedText>
                  <Underline className={styles.underline} />
                </div>
              </div>
            </Flex>
          ))}
        </Flex>
        <ExtendedText variant="heading-16" color="kale-3" align="center">
          Get fresh, human-grade food (for your dog)
          <br />
          delivered right to your door.
        </ExtendedText>
        <Flex direction="column" align="center">
          <SeePlansAndPricingButton />
          <GiveUsACall />
        </Flex>
      </div>
      <Flex
        direction="row"
        justify="space-between"
        alignItems="center"
        gap="sm"
        className={styles.desktopWrapper}
      >
        <Flex direction="column" gap="md">
          <Flex direction="row">
            {TITLE_DATA.map(({ left, right, Underline }, index) => (
              <Flex
                key={index}
                direction="row"
                aria-label={`${left} by ${right}`}
              >
                <ExtendedText variant="heading-28" bold color="kale-3">
                  {left} by{' '}
                </ExtendedText>
                <div className={styles.lazyDogTextContainer}>
                  <ExtendedText
                    as="div"
                    variant="lazy-dog-32"
                    color="kale-3"
                    className={styles.lazyDogText}
                  >
                    {right}.
                  </ExtendedText>
                  <Underline className={styles.underline} />
                </div>
              </Flex>
            ))}
          </Flex>
          <ExtendedText variant="heading-22" color="kale-3" align="left">
            Get fresh, human-grade food (for your dog) delivered right to your
            door.
          </ExtendedText>
        </Flex>
        <Flex direction="column" align="center">
          <SeePlansAndPricingButton />
          <GiveUsACall />
        </Flex>
      </Flex>
    </Section>
  );
};
